import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  setClassesOrSeriesAction,
  setDeleteManadatedClassAction,
} from "../../../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";
import {
  deleteMandatedClassesActionHandler,
  mandatedClassesActionHandler,
} from "../../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../../utils/errorTypes";
import CardContainer from "../CardContainer/CardContainer";
import classes from "./ManageClasses.module.scss";
import { frequncyNameConverter } from "../ManageMandatoryLearnings";
import { useSelector } from "react-redux";

const ClassList = ({
  radioBtnVal,
  classDetails,
  repititiveValArr,
  setValue,
  getUserGroupMandateShotClasses,
  selectVal,
  getValues,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedRepetitveVal, setSelectedRepetitveVal] = useState("");
  const [selectedRadioBtnVal, setSelectedRadioBtnVal] = useState("");
  const adminState = useSelector((state) => state.adminReducer);
  const { groupManagementReducer } = adminState;
  const { classOrSeriesData } = groupManagementReducer;

  const onRadioChange = (e, id, frequencyName) => {
    const val = e?.target?.value;
    setSelectedRadioBtnVal(val);
    const updatedData = classDetails?.map((data) => {
      if (data?.ShotClass?.ID === id) {
        return {
          ...data,
          ShotClass: {
            ...data?.ShotClass,
            radioBtnVal: val,
            IsRepetitive: val === "Repetitive",
          },
        };
      } else return data;
    });
    dispatch(setClassesOrSeriesAction(updatedData));
    if (val === radioBtnVal[1] && frequencyName === "NONE") {
      setValue(`repetitive${id}`, "Monthly");
    }
  };

  const handleDelete = (classId, name) => {
    dispatch(
      deleteMandatedClassesActionHandler(classId, params?.userGroupId)
    ).then((response) => {
      if (response?.status === 200 && response?.data) {
        dispatch(setDeleteManadatedClassAction(response?.data));
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Shotclasses "${
              name?.length > 30 ? name?.slice(0, 30) + "..." : name
            }" is de-linked from user group successfully`
          )
        );
        getUserGroupMandateShotClasses("ShotClass");
      } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
    });
  };

  const onSaveClick = (data) => {
    const id = data?.ID;
    const name = data?.Name;
    if (selectedRadioBtnVal === radioBtnVal[1] || data?.IsRepetitive) {
      if (data?.selectedDropdownVal || data?.FrequencyName !== "NONE") {
        dispatch(
          mandatedClassesActionHandler(
            id,
            params?.userGroupId,
            1,
            selectedRepetitveVal === ""
              ? frequncyNameConverter(data?.FrequencyName)
              : selectedRepetitveVal
          )
        ).then((response) => {
          if (response?.status === 200 && response?.data) {
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                `Successfully Mandated the Shotclasses`
              )
            );
          } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
        });
      } else {
        dispatch(setErrorHandler(errorTypes?.WARN, "Please Select Frequency"));
      }
    } else
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          `Shotclasses "${
            name?.length > 30 ? name?.slice(0, 30) + "..." : name
          }" is already linked to the User group`
        )
      );
  };

  const onSelectChange = (val, id) => {
    const updatedData = classOrSeriesData?.map((data) => {
      if (data?.ShotClass?.ID === id) {
        return {
          ...data,
          ShotClass: {
            ...data?.ShotClass,
            selectedDropdownVal: val,
          },
        };
      } else return data;
    });
    dispatch(setClassesOrSeriesAction(updatedData));
    switch (val) {
      case "Monthly":
        setSelectedRepetitveVal("1");
        break;
      case "Quarterly":
        setSelectedRepetitveVal("2");
        break;
      case "Yearly":
        setSelectedRepetitveVal("3");
        break;
      default:
        setSelectedRepetitveVal("");
        break;
    }
  };

  return (
    <div className={classes.cardContainer}>
      {classOrSeriesData?.length > 0 &&
        classOrSeriesData?.map((data, index) => (
          <CardContainer
            data={data?.ShotClass}
            handleDelete={handleDelete}
            repititiveValArr={repititiveValArr}
            onSelectChange={onSelectChange}
            radioBtnVal={radioBtnVal}
            onRadioChange={onRadioChange}
            onSaveClick={onSaveClick}
            key={data?.ShotClass?.ID}
            dropDownName={`repetitive${data?.ShotClass?.ID}`}
            radioBtnFieldName={`priority${data?.ShotClass?.ID}`}
            radioBtnName={`priority${data?.ShotClass?.ID}`}
            selectVal={selectVal}
            isDelete
            selectedRepetitveVal={selectedRepetitveVal}
          />
        ))}
    </div>
  );
};

export default ClassList;
